/** @type {import('../help-index.js').HelpScreen} */
export const SETTINGS_CURRENCIES_HELP = {
  screenId: 'settings-currencies',
  label: 'Monedas',
  navPath: 'Configuración → Monedas',
  keywords: ['cotización', 'dólar', 'tipo de cambio', 'usd', 'ars', 'moneda extranjera'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Monedas de la empresa y tipos de cambio usados en ventas, compras y comprobantes electrónicos.',
  sidebarItems: [{
    id: 'currencies-list',
    screenId: 'settings-currencies',
    label: 'Lista de monedas',
    description: 'Ver monedas cargadas, agregar nuevas y actualizar cotizaciones.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Definís qué monedas usa tu empresa (pesos, dólares, etc.) y su tipo de cambio. Esos valores se usan al facturar, cobrar, pagar y convertir importes entre monedas.',
        },
        {
          title: 'Antes de empezar',
          paragraphs: [
            'Para crear monedas nuevas necesitás permiso de configuración de monedas. Para ver la lista alcanza con permiso de administración.',
            'La moneda ARS (pesos) suele venir precargada; su tipo de cambio no se puede modificar.',
          ],
        },
        {
          title: 'Paso 1 — Ver la lista',
          steps: [
            'Entrá a Configuración → Monedas.',
            'La lista muestra: Código, Descripción, Tipo de cambio y Código ARCA.',
            'Podés cambiar de página y descargar la lista si lo necesitás.',
          ],
        },
        {
          title: 'Paso 2 — Agregar una moneda',
          steps: [
            'Tocá el botón + (arriba a la izquierda).',
            'Completá Código de moneda (ej. USD) y Descripción.',
            'Ingresá el Tipo de cambio: número mayor a cero respecto a la moneda base.',
            'Opcional: elegí Código ARCA en el desplegable (lista oficial de AFIP para comprobantes electrónicos).',
            'Tocá «Crear moneda».',
          ],
          paragraphs: [
            'No podés repetir un código que ya exista ni un código ARCA ya usado por otra moneda.',
          ],
        },
        {
          title: 'Paso 3 — Actualizar el tipo de cambio',
          steps: [
            'Tocá una fila de la lista (excepto ARS).',
            'Se abre una ventana con el código, descripción y código ARCA en solo lectura.',
            'Modificá el Tipo de cambio y tocá «Guardar».',
          ],
          paragraphs: [
            'Si la moneda es ARS, la ventana solo permite consultar; el botón Guardar no aparece.',
          ],
        },
      ],
    },
  }],
}
